import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, App} from 'ionic-angular';
import { DesafioPersonalProvider } from '@providers/desafio-personal/desafio-personal';
import { AuthProvider } from '@providers/auth/auth';
import { Jugador } from '@domain/jugador';
import { Equipo } from '@domain/equipo';
import { ASSETS } from '@env';
import { CargadorPcPage } from '../../personal-challenge/cargador-pc/cargador-pc';
import { LoadingProvider } from '@providers/loading/loading';
import { ModalRetosPausadosComponent } from '../../../components/modal-retos-pausados/modal-retos-pausados';

@IonicPage()
@Component({
  selector: 'page-buscar-tc',
  templateUrl: 'buscar-tc.html',
})
export class BuscarTcPage {

  jugador: Jugador;
  equipo: Equipo;
  jugadores: Array<any> = [];
  jugadoresRequest: Boolean = false;
  AVATAR_PLAYER = ASSETS.AVATAR_PLAYER;

  @ViewChild(ModalRetosPausadosComponent) modalRetosPausados: ModalRetosPausadosComponent;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private app: App,
    private desafioPersonalProvider: DesafioPersonalProvider,
    private authProvider: AuthProvider,
    private loadingProvider: LoadingProvider
  ) {

      this.authProvider.getSession()
      .then( jugador => {
        this.jugador = jugador;
        return this.authProvider.getEquipo();
      })
      .then( equipo => {
        this.equipo = equipo;
      });
  }

  ionViewDidLoad() {
  }

  async puedeRetar() {
    const _puedeJugar = await this.desafioPersonalProvider.puedeRetar(this.equipo.area._id);
    return _puedeJugar.jugar;
  }

  async retoDirecto(retador: string) {
    this.loadingProvider.show(true);
    
    try {
      const _puedeJugar = await this.puedeRetar();
      if(!_puedeJugar) {
        this.modalRetosPausados.show = true;
        this.loadingProvider.show(false);
        return;
      }
      
      let juego = await this.desafioPersonalProvider.directo(this.equipo.area._id, this.jugador._id, retador);
      this.app.getRootNavs()[0].setRoot(CargadorPcPage, {
        jugador: this.jugador,
        equipo: this.equipo,
        juego:  juego
      });
    } catch (e) {
      console.log(e);
    } finally {
      this.loadingProvider.show(false);
    }
  }

  async search(e) {
    if(!e.target.value) {
      this.jugadores = [];
      return false;
    };

    this.jugadoresRequest = true;

    try {
      this.jugadores = await this.desafioPersonalProvider.buscar(this.equipo.area._id, this.jugador._id, e.target.value)
    } catch (e) {
      console.log(e);
    } finally {
      this.jugadoresRequest = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/team-challenge/buscar-tc/buscar-tc.ts